import { Col, Row } from "react-bootstrap";
import './XXXWIcon.css';

export default function XXXWIcon() {

    return (
        <Row id='xxxw'>
            <Col>
                <div className="cardStyle d-flex flex-column align-items-center justify-content-center">
                    <Row>
                        <Col className="d-flex align-items-center justify-content-center">
                            <div className="textStyle">星宿图画</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex align-items-center justify-content-center">
                            <div className="textStyle">旗开得胜</div>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    )
}